var _a, _b, _c, _d, _e;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { ShareSpaceModel } from '@/domains/share-space/models/share-space-model';
import { UserEntity } from '@/types/user-entity';
import { SpaceOrFolder } from '@/domains/share-space/enums';
import { PatentViewTypeService } from '@/services/patent-view-type-service';
import { updateShareApi } from '@/presentation/components/CombinedShare/api';
import { Message } from '@patsnap/tahiti-core/common/message';
import { I18nService } from '@/services/i18n-service';
import { transformCollaboratorToApiField } from '@/domains/share-space/utils/collaborator-permission';
import { RavenService } from '@cores/modules/raven-module/raven-service';
let ShareSpaceServiceImpl = class ShareSpaceServiceImpl {
    constructor(_shareSpaceModel, _patentViewTypeService, _message, _i18nService, _ravenService) {
        this._shareSpaceModel = _shareSpaceModel;
        this._patentViewTypeService = _patentViewTypeService;
        this._message = _message;
        this._i18nService = _i18nService;
        this._ravenService = _ravenService;
    }
    async shareSpace(inviteCtrl) {
        const { syncDisplayField, shareExpiryAt, spaceId, folderId, type, spaceType } = this._shareSpaceModel.modelData;
        const receivers = inviteCtrl.collaborators.map((user) => {
            return {
                receiver_id: user.uid,
                receiver_type: user.type,
                user_role: user.userRole,
                permission_detail: user.userRole === UserEntity.USER_ROLE_MAP.CUSTOM
                    ? transformCollaboratorToApiField(user.permissions)
                    : undefined,
                sync_display_field: syncDisplayField,
                share_expiry_at: shareExpiryAt,
            };
        });
        const req = {
            space_id: spaceId,
            folder_id: type === SpaceOrFolder.FOLDER
                ? folderId
                : undefined,
            add_permissions: receivers,
            view_type: this._patentViewTypeService.getPatentViewPathId(),
        };
        this._ravenService.track('Submit Share Space Request', {
            other_param: spaceType,
            other_param1: receivers.length,
        });
        try {
            await updateShareApi(req);
            this._message.success({
                message: this._i18nService.t('workspace.share.submitOk'),
                showClose: true,
            });
        }
        catch (e) {
            this._message.error({
                message: this._i18nService.t('workspace.share.noshare'),
                showClose: true,
            });
        }
    }
};
ShareSpaceServiceImpl = __decorate([
    injectable(),
    __param(0, inject(ShareSpaceModel)),
    __param(1, inject(PatentViewTypeService)),
    __param(2, inject(Message)),
    __param(3, inject(I18nService)),
    __param(4, inject(RavenService)),
    __metadata("design:paramtypes", [typeof (_a = typeof ShareSpaceModel !== "undefined" && ShareSpaceModel) === "function" ? _a : Object, typeof (_b = typeof PatentViewTypeService !== "undefined" && PatentViewTypeService) === "function" ? _b : Object, typeof (_c = typeof Message !== "undefined" && Message) === "function" ? _c : Object, typeof (_d = typeof I18nService !== "undefined" && I18nService) === "function" ? _d : Object, typeof (_e = typeof RavenService !== "undefined" && RavenService) === "function" ? _e : Object])
], ShareSpaceServiceImpl);
export { ShareSpaceServiceImpl };
